import {lazy} from 'react'

const GiftShopEditProfile2FAEmailStatusScreen = lazy(
  () => import('./GiftShopEditProfile2FAEmailStatusScreen'),
)

const GiftShopEditProfileScreen = lazy(
  () =>
    import(/* webpackChunkName: 'EditProfile' */ './GiftShopEditProfileScreen'),
)

const GiftShopEditProfileChangePasswordStatusScreen = lazy(
  () =>
    import(
      /* webpackChunkName: 'EditProfileChangePasswordStatus' */ './GiftShopEditProfileChangePasswordStatusScreen'
    ),
)

const GiftShopEditProfileResetPasswordScreen = lazy(
  () =>
    import(
      /* webpackChunkName: 'EditProfileResetPassword' */ './GiftShopEditProfileResetPasswordScreen'
    ),
)

export * from './GiftShopEditProfileScreenParam'

export {
  GiftShopEditProfile2FAEmailStatusScreen,
  GiftShopEditProfileScreen,
  GiftShopEditProfileChangePasswordStatusScreen,
  GiftShopEditProfileResetPasswordScreen,
}
